import { Injectable } from '@angular/core';

import { AnalyticsEventCategory } from '../../../shared/configs/analytics-event-category.config';
import { AnalyticsEventTypes } from '../../../shared/configs/analytics-event-types.config';
import { UserDetailsService } from '../user-details/user-details.service';

declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor(private userDetailsService: UserDetailsService) {}

  sendEvent(
    eventType: AnalyticsEventTypes,
    eventCategory: AnalyticsEventCategory,
    eventLabel: string,
  ): void {
    const user = this.userDetailsService.userDetails;

    gtag('event', eventType, {
      event_label: eventLabel,
      event_category: eventCategory,
      userId: user.id,
      userType: user.roles[0].name,
      userAge: user.age,
      userState: user.state,
      centreId: user.centre_id,
      centreName: user.centre,
      orgId: user.organisation_id,
      orgName: user.organisation,
      userGender: user.gender,
    });
  }

  sendPageInteractionEvent(eventName: string, params: Map<string, any> = new Map()): void {
    const user = this.userDetailsService.userDetails;
    const paramsObject = this.mapToObject(params);

    gtag('event', eventName, {
      userId: user?.id,
      ...paramsObject,
    });
  }

  sendPageViewEvent(
    pageName: string,
    timeSpent: number,
    bounce: boolean,
    params: Map<string, any> = new Map(),
  ): void {
    const user = this.userDetailsService.userDetails;
    const paramsObject = this.mapToObject(params);

    gtag('event', 'page_view', {
      page_name: pageName,
      time_spent: timeSpent,
      bounce,
      userId: user?.id,
      ...paramsObject,
    });
  }

  private mapToObject(map: Map<string, any>): Record<string, any> {
    const obj: Record<string, any> = {};

    map.forEach((value, key) => {
      obj[key] = value;
    });

    return obj;
  }
}
